import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { Constants } from 'src/app/shared/constants';

@Directive({
  selector: '[appMaskEmail]'
})
export class MaskEmailDirective {
  previousValue: string;
  maskemail = true;
  updatePrevious = false;
  @Input() params: any;
  setvalidator = true;

  constructor(private element: ElementRef, private control: NgControl) { }
  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewChecked(): void {
    this.control.control.setValidators([Validators.required, Validators.pattern(Constants.EMAIL_REGEX)]);
    if (this.params.isRenewal) {
      if (this.maskemail) {
        const emailRegex = '\\S(?<=.{' + this.params.noFirstShowChar + '})(?=\\S{' + this.params.noLastShowChar + '})';
        const rx = new RegExp(emailRegex, 'gm');
        const subst = `*`;
        const initalValue = this.element.nativeElement.value;
        this.element.nativeElement.value = initalValue.replace(rx, subst);
        if (this.control.control.value !== null) {
          this.previousValue = this.control.control.value;
        }
        this.control.control.setValidators([Validators.required]);
        this.control.control.updateValueAndValidity();
      }
    } else {
      if (this.setvalidator) {
        this.control.control.setValidators([Validators.required, Validators.pattern(Constants.EMAIL_REGEX)]);
        this.control.control.updateValueAndValidity();
        this.setvalidator = false;
      }
    }

  }
  @HostListener('input', ['$event'])
  onKeyDown(event) {
    if (this.params.isRenewal && !this.updatePrevious) {
      // this.element.nativeElement.value = this.previousValue;
      this.element.nativeElement.value = '';
      this.updatePrevious = true;
      this.control.control.setValidators([Validators.required, Validators.pattern(Constants.EMAIL_REGEX)]);
      this.control.control.updateValueAndValidity();
      this.maskemail = false;
    }
  }

}
